<template>
    <div class="col-12">

        <div v-show="makePaymentElement">
            <div class=" row text-center m-5">
                <h3 v-if="success" class="ui inverted purple text"> <strong> {{ title }}</strong>
                </h3>
                <h3 v-if="!success" class="ui inverted purple text"><strong> {{ title
                }}</strong>
                </h3>

            </div>
            <div class="row d-flex justify-content-center align-items-center mt-5">
                <div class="col-11 col-lg-9">
                    <div class="ui violet floating message m-4">
                        <div class="header mb-2">
                            <div v-if="loadingRequest" class="ui active inline loader"></div>
                            {{ subTitle }}
                        </div>
                        <p> {{ message }}</p>
                    </div>
                    <button v-if="retryButton && !submitDocumentsLater" class="ui button  purple fluid mt-4 mb-4"
                        @click="startPayment()">Retry
                        Payment</button>
                    <button v-if="retryButton && submitDocumentsLater" class="ui button  purple fluid mt-4 mb-4"
                        @click="submitDocsLater()">Retry @
                        Payment</button>
                    <button v-if="logoutButton" class="ui button  grey fluid mt-4 mb-4" @click="login()">Logout</button>

                </div>
            </div>
        </div>


    </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import { URLS } from "@/utils/constants";
//import { http } from "@/utils/http";
//import { Notify } from "@/utils/notifications";
//import { utils } from "@/utils/utils";

export default {
    name: "DiasporaAccountPayments",
    data() {
        return {
            makePaymentElement: true,
            accounts: [],
            subTitle: '',
            title: '',
            message: '',
            missingFile: '',
            success: true,
            retryButton: false,
            loadingRequest: true,
            isChecked: false,
            submitDocumentsLater: false,
            logoutButton: false,
            uploadDocumentsElement: false,
            customer: {
                mobileNumber: localStorage.getItem("phone-number"),
                email: localStorage.getItem("email"),
                title: localStorage.getItem("title"),
                firstName: localStorage.getItem("first-name"),
                lastName: localStorage.getItem("last-name"),
                idNumber: localStorage.getItem("identity-doc-no"),
                gender: localStorage.getItem("gender"),
                street: localStorage.getItem("street"),
                town: localStorage.getItem("town"),
                branch: localStorage.getItem("branch"),
                currency: localStorage.getItem("currency-type"),
                dateOfBirth: localStorage.getItem("dateOfBirth"),
                lineOfBusiness: localStorage.getItem("lineOfBusiness"),
                sourceOfIncome: localStorage.getItem("sourceOfIncome"),
                monthlyIncomeAmount: localStorage.getItem("monthlyIncomeAmount"),
                activityExpectedOnAccount: localStorage.getItem("activityExpectedOnAccount"),
                signature: localStorage.getItem("signature"),
                customerUid: localStorage.getItem("uid"),
                accountUid: localStorage.getItem("account-uid"),
                country: localStorage.getItem("country"),
                requestType: "PRE_PROCESS_DIASPORA_ACCOUNT",
                accountType: "DIASPORA",
                status: 'PENDING',
            },
        };
    },
    mounted() {
        this.startPayment();
    },
    methods: {
        login() {
            this.$router.push("/account-opening/login");
        },
        startPayment() {
            this.setDefaults();


            this.postNoAuthAndNoBaseUrl(
                URLS.processAccount,
                this.customer,
                "Customer Data Uploaded",
                null,
                true
            ).then((res) => {
                if (!res) return;
                if (res.errors) return (this.errors = res.errors);
                if (res.body.status === "COMPLETE") {
                    this.title = 'Complete';
                    this.message = 'Your application has been submitted successfully. Once authorized, your account number will be sent to you via SMS. Thank you for choosing TN CyberTech Bank!';
                    this.subTitle = 'TN CyberTech Bank';
                    this.success = true;
                    this.logoutButton = true;
                    this.loadingRequest = false;
                    localStorage.clear()

                } else {
                    if (res.body.requestType === "ECOCASH_DEPOSIT") {
                        this.title = 'Sorry, Payment Authorization Failed'
                        this.success = false;
                        this.message = 'Click the button below to retry the payment process.';
                        this.retryButton = true;
                        this.logoutButton = true;
                        this.loadingRequest = false;

                    }
                    this.title = 'Very Sorry, An Error Has Occurred'
                    this.success = false;
                    this.message = 'Click the button below to retry the payment process. If the error persists, please contact us on 0808 8888 or customerservice@stewardbank.co.zw for assistance.';
                    this.retryButton = true;
                    this.logoutButton = true;
                    this.loadingRequest = false;

                }
            });
        },

        setDefaults() {

            this.message = 'In approximately 10 seconds you will be asked to enter your EcoCash PIN  on your mobile phone to facilitate the account opening fee. This will enable us to co that we can accept your account opening request.';
            this.title = 'Almost Done!';
            this.subTitle = 'Pending Ecocash Payment Authorization';
            this.success = true;
            this.retryButton = false;
            this.logoutButton = false;
            this.loadingRequest = true;
        },
        ...baseMethods,
    }
};
</script>